import React from "react";
import "./Section3.css";

import onlineOrderImage from "../images/Delivery guy.png";
import takeawayImage from "../images/Take Away.png";
import cateringImage from "../images/Catering service.png";

const Section3 = () => {
  return (
    <div>
      <div className="weoffer-sec">
        <h1 className="content-heading" data-aos="fade-down">
          Embark on a Journey Through India's Finest Flavours
        </h1>

        <div className="weoff-main-card">
          {/* Online Order Card */}
          <div className="card-weoffer">
            <div className="card-weoffer-image">
              <img src={onlineOrderImage} alt="Online Orders" className="weoff-img" />
            </div>
            <div className="weoff-text">
              <div className="weoff-text-header">
                <p className="weoff-text-heading">ONLINE ORDER</p>
              </div>
              <p className="weoff-details">
                Enjoy the rich, authentic taste of Indian cuisine from the comfort of your home. 
                Place your online orders with us and experience flavors delivered right to your doorstep.
              </p>
              <button className="weoff-action-button">Order Now</button>
            </div>
          </div>

          {/* Takeaway Service Card */}
          <div className="card-weoffer">
            <div className="card-weoffer-image">
              <img src={takeawayImage} alt="Takeaway Service" className="weoff-img" />
            </div>
            <div className="weoff-text">
              <div className="weoff-text-header">
                <p className="weoff-text-heading">TAKEAWAY SERVICE</p>
              </div>
              <p className="weoff-details">
                Relish the same authentic taste of India at home with our efficient takeaway service. 
                Enjoy freshly prepared dishes wherever you are—at home, in the office, or any place you choose. 
                Fast, easy, and full of flavor!
              </p>
              <button className="weoff-action-button">Takeaway Now</button>
            </div>
          </div>

          {/* Catering Service Card */}
          <div className="card-weoffer">
            <div className="card-weoffer-image">
              <img src={cateringImage} alt="Catering Service" className="weoff-img" />
            </div>
            <div className="weoff-text">
              <div className="weoff-text-header">
                <p className="weoff-text-heading">CATERING SERVICE</p>
              </div>
              <p className="weoff-details">
                Make your events memorable with our premium catering service. 
                From small gatherings to grand celebrations, we bring authentic Indian flavors to the table, 
                making every occasion truly special.
              </p>
              <button className="weoff-action-button">Book Now</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
